import type { MissionConfig } from "../mission/types";

type MissionCard = {
  config: MissionConfig;
  desc: string;
  hint: string;
};

export class MissionSelectScreen {
  private readonly el: HTMLElement;

  constructor(
    private readonly cards: MissionCard[],
    private readonly onSelect: (config: MissionConfig) => void,
    private readonly onBack?: () => void,
  ) {
    this.el = document.createElement("div");
    this.el.id = "mission-select";
    this.el.className = "screen-overlay screen-overlay--stacked";
    this.el.style.zIndex = "400";
    document.body.appendChild(this.el);
    this.el.addEventListener("click", this.handleClick);
    this.render();
  }

  private render(): void {
    const cardHtml = this.cards
      .map(
        ({ config, desc, hint }) => `
        <div class="screen-card" data-mission="${config.id}">
          <div class="screen-card__title">${config.name}</div>
          <div class="screen-copy">${desc}</div>
          <div class="screen-hint">${hint}</div>
          <div class="screen-actions" style="justify-content:flex-start;margin-top:14px">
            <button class="screen-button screen-button--small" data-select="${config.id}">SELECT</button>
          </div>
        </div>`,
      )
      .join("");

    const backBtn = this.onBack
      ? `<div class="screen-actions" style="margin-top:10px"><button id="ms-back" class="screen-button screen-button--muted screen-button--small">BACK</button></div>`
      : "";
    this.el.innerHTML = `
      <div class="screen-kicker">TEST RANGE</div>
      <div class="screen-title">SELECT MISSION</div>
      <div class="screen-card-grid">${cardHtml}</div>
      ${backBtn}
      <div class="screen-footer">CLICK CANVAS TO LOCK MOUSE &nbsp;|&nbsp; ESC = PAUSE &nbsp;|&nbsp; 1/2/3 = WEAPON &nbsp;|&nbsp; WASD = ORBIT &nbsp;|&nbsp; HOLD RMB = ZOOM</div>
    `;
  }

  show(): void {
    this.el.classList.add("is-visible");
  }

  hide(): void {
    this.el.classList.remove("is-visible");
  }

  private handleClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement | null;
    if (target?.closest("#ms-back")) {
      this.hide();
      this.onBack?.();
      return;
    }
    const id = target?.closest<HTMLElement>("[data-select]")?.dataset["select"];
    if (!id) return;
    const card = this.cards.find((c) => c.config.id === id);
    if (!card) return;
    this.hide();
    this.onSelect(card.config);
  };
}
